import { render, staticRenderFns } from "./UserType.vue?vue&type=template&id=7bbeba1a"
import script from "./UserType.vue?vue&type=script&lang=js"
export * from "./UserType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports